<template>
    <div :class="{ 'compact-sheet-list': compact }">
        <b-row v-for="(position, rowIndex) in positionsFirstHalf" :key="position.pid" :class="rowTextClass(rowIndex)" class="small">
            <b-col class="formatPrice">{{ formatTimeFromISO(position.open_time) }}</b-col>
            
            <b-col class="formatPrice text-success" v-if="getIndicator(position) >= 10">+{{ getIndicator(position) }}%</b-col>
            <b-col class="formatPrice text-info" v-else-if="getIndicator(position) >= 9">+{{ getIndicator(position) }}%</b-col>
            <b-col class="formatPrice text-white" v-else>+{{ getIndicator(position) }}%</b-col>

            <b-col class="formatPrice" cols="3">{{ formatPrice(position.open_price) }} &#x21E2;</b-col>
            <b-col class="formatPrice" cols="2">{{ formatPrice(position.close_price) }}</b-col>
        </b-row>

        <b-row v-if="positionsSecondHalf.length" class="text-center text-secondary">
            <b-col>- - -</b-col>
        </b-row>

        <b-row v-for="(position, rowIndex) in positionsSecondHalf" :key="position.pid" :class="rowTextClass(rowIndex+1)" class="small">
            <b-col class="formatPrice">{{ formatTimeFromISO(position.open_time) }}</b-col>
            
            <b-col class="formatPrice text-success" v-if="getIndicator(position) >= 10">+{{ getIndicator(position) }}%</b-col>
            <b-col class="formatPrice text-info" v-else-if="getIndicator(position) >= 9">+{{ getIndicator(position) }}%</b-col>
            <b-col class="formatPrice text-white" v-else>+{{ getIndicator(position) }}%</b-col>

            <b-col class="formatPrice" cols="3">{{ formatPrice(position.open_price) }} &#x21E2;</b-col>
            <b-col class="formatPrice" cols="2">{{ formatPrice(position.close_price) }}</b-col>
        </b-row>
    </div>
</template>

<script>
import formatter from "@/mixins/formatter";
import { POSITION_LIST_FULL_LIMIT, POSITION_LIST_EDGE_ROWS } from '@/constants/trading';

export default {
    name: "CompactPositionList",
    // totalCount: how many positions exist when positionList is only a sample
    props: {
        positionList: null,
        refPrice: null,
        totalCount: null,
        compact: Boolean,
    },
    mixins: [formatter],
    methods: {
        getIndicator(position) {
            if (this.refPrice) return ((this.refPrice / position.open_price) * 100 - 100).toFixed(2);
            return position.indicator;
        },
        rowTextClass(rowIndex) {
            if (this.compact) return null;
            if (rowIndex % 2) return 'text-secondary';
            return 'text-light';
        },
    },
    computed: {
        splitLongList() {
            const total = this.totalCount ?? this.positionList.length;
            return total > POSITION_LIST_FULL_LIMIT;
        },
        positionsFirstHalf() {
            if (this.splitLongList) return this.positionList.slice(0, POSITION_LIST_EDGE_ROWS);
            return this.positionList;
        },
        positionsSecondHalf() {
            if (!this.splitLongList) return [];
            // not slice(-EDGE_ROWS): an exit can shrink a sampled list below
            // EDGE_ROWS * 2, and then head and tail overlap and repeat a row
            const tailStart = Math.max(POSITION_LIST_EDGE_ROWS, this.positionList.length - POSITION_LIST_EDGE_ROWS);
            return this.positionList.slice(tailStart);
        }
    }
}
</script>

<style>
/* the exit sheet's list: small and dense, because the user only checks it from time to time */
.compact-sheet-list {
    font-family: var(--font-family-monospace);
    color: var(--sheet-muted);
}
.compact-sheet-list > .row {
    margin: 0;
    padding: 3px 8px;
    border-radius: 4px;
    font-size: 11.5px;
}
.compact-sheet-list > .row:nth-child(odd) {
    background: #111;
}
.compact-sheet-list > .row > [class*='col'] {
    padding: 0 2px;
}
</style>
